<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <img :src="info" height="25px" />
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">
            <valueLabelSection :titleLabel="contentTitle"></valueLabelSection>
            <inputSection
              :titleLabel="adminMailAddressTitle"
              @inputUpdate="inputUpdateDefineInfo('adminMailAddress')"
            ></inputSection>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="okButton"
              class="finish_button"
              @click="showConfirmModal = true"
            />
          </div>
        </div>
        <div class="modal_window" v-if="showConfirmModal">
          <confirmModalWindow
            :question="confirmWord"
            @close="stayClose"
            @ok="updateAdminMailAddress"
          >
          </confirmModalWindow>
        </div>
        <div class="complete_modal_window" v-if="showCompleteModal">
          <finishModalWindow :question="completeWord" @close="close">
          </finishModalWindow>
        </div>
        <div class="modal_window" v-if="showFailureModal">
          <finishModalWindow :question="failureWord" @close="stayClose">
          </finishModalWindow>
        </div>
        <div class="loading_modal_window" v-if="showloadingModal">
          <loadingModalWindow @close="close"> </loadingModalWindow>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import valueLabelSection from './modalwindowComponents/valueLabelSection.vue'
import inputSection from './modalwindowComponents/inputSection.vue'
import textAreaSection from './modalwindowComponents/textAreaSection.vue'
import confirmModalWindow from './confirmModalWindow.vue'
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      info: require('../../../../img/info.png'),
      title: '管理者メールアドレス更新',
      contentTitle: '更新後のメールアドレスを入力してください。',
      adminMailAddressTitle: '管理者メールアドレス:',
      cancelButton: 'キャンセル',
      okButton: '更新',
      completeWord: '',
      failureWord: '',
      confirmWord: '管理者メールアドレスを更新しますか？',
      showConfirmModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false
    }
  },
  computed: {
    backgroundColor() {
      if (
        this.showCompleteModal === true ||
        this.showConfirmModal === true ||
        this.showFailureModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    adminMailAddress() {
      return this.$store.state.corporationsCommonOption.adminMailAddress
    }
  },
  components: {
    valueLabelSection,
    inputSection,
    textAreaSection,
    confirmModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  created() {
    this.$store.dispatch('corporationsCommonOption/cleareDefineInfo')
  },
  methods: {
    close(e) {
      this.$emit('close')
    },
    stayClose(e) {
      this.showFailureModal = false
      this.showConfirmModal = false
    },
    inputUpdateDefineInfo(e) {
      this.$store.dispatch('corporationsCommonOption/inputUpdateDefineInfo', {
        name: e,
        value: event.target.value
      })
    },
    async updateAdminMailAddress() {
      this.showloadingModal = true
      this.showConfirmModal = false
      if (this.adminMailAddress === null || this.adminMailAddress === '') {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_640001
        this.failureWord =
          this.sysErrorMsg.MSGCRD0088.name +
          this.sysErrorMsg.MSGCRD0088.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch('corporationsCommonOption/updateDefineInfo')
        this.completeWord = '変更しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_640001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0061')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>
<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 391px;
  padding-top: 40px;
}
.modal_container {
  height: 320px;
}
.modal_header {
  background-color: #33ccff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/adminMailAddressModalWindow.vue